// Text-based Pinkwater® wordmark label used in the brand tab (no logo image).
export default function PinkwaterLabel({ size = "md" }) {
  const scale =
    size === "lg"
      ? { name: "text-[30px]", sub: "text-[9px]" }
      : { name: "text-[22px]", sub: "text-[8px]" };
  return (
    <div className="flex flex-col items-center justify-center leading-none select-none">
      <span
        className={`${scale.name} font-heading font-bold tracking-tight`}
        style={{ fontFamily: "Oswald, sans-serif", color: "#d81b76" }}
      >
        Pinkwater<span className="align-super text-[0.5em]">®</span>
      </span>
      <span
        className={`${scale.sub} uppercase tracking-[0.28em] text-[#7a5566] mt-1`}
      >
        Surfactants
      </span>
    </div>
  );
}
